import { ReactNode } from 'react'
import { Icon } from '@iconify/react'
import { Drawer } from '@pepper/ui'

type Props = {
  open: boolean
  onClose: () => void
  className?: string
  title: ReactNode
  children: React.ReactNode
}

export const IdeaLabDrawer = ({
  onClose,
  open,
  className,
  title,
  children,
}: Props) => {
  return (
    <Drawer
      bodyStyle={{ padding: 0 }}
      placement="right"
      destroyOnClose={true}
      className={className}
      closeIcon={
        <Icon
          icon="feather:x"
          width={20}
          height={20}
          data-id="discovery-sidebar-close-button"
        />
      }
      onClose={onClose}
      visible={open}
      width="60%"
      title={title}
    >
      {children}
    </Drawer>
  )
}
